import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center z-index-1 w-100" }
const _hoisted_3 = ["alt"]
const _hoisted_4 = { class: "bg-white rounded p-5 print-pt-0" }
const _hoisted_5 = { class: "pdf-item" }
const _hoisted_6 = { class: "pt-3" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "my-5" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  key: 3,
  class: "border-top border-dark p-3 mt-5"
}
const _hoisted_13 = {
  class: "mt-3",
  style: {"font-weight":"400"}
}
const _hoisted_14 = { class: "text-center py-5" }
const _hoisted_15 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_16 = { class: "px-5" }
const _hoisted_17 = { class: "h5" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "h5 px-5" }
const _hoisted_21 = {
  key: 0,
  class: "border-end border-start border-dark px-10 px-5"
}
const _hoisted_22 = {
  key: 1,
  class: "border-end border-start border-dark px-10 px-5"
}
const _hoisted_23 = { class: "px-5" }
const _hoisted_24 = { class: "h5" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = {
  key: 1,
  class: "d-flex justify-content-center"
}
const _hoisted_28 = { class: "h5 px-5" }
const _hoisted_29 = {
  key: 0,
  class: "px-5"
}
const _hoisted_30 = {
  key: 1,
  class: "px-5"
}
const _hoisted_31 = { class: "h5 px-5" }
const _hoisted_32 = {
  key: 0,
  class: "border-start border-dark px-10 px-5"
}
const _hoisted_33 = {
  key: 1,
  class: "border-start border-dark px-10 px-5"
}
const _hoisted_34 = { key: 2 }
const _hoisted_35 = { class: "h5" }
const _hoisted_36 = {
  key: 0,
  class: "h5"
}
const _hoisted_37 = {
  key: 1,
  class: "h5"
}
const _hoisted_38 = { key: 3 }
const _hoisted_39 = { class: "h5" }
const _hoisted_40 = {
  key: 0,
  class: "h5"
}
const _hoisted_41 = {
  key: 1,
  class: "h5"
}
const _hoisted_42 = { key: 4 }
const _hoisted_43 = {
  key: 0,
  class: "h5"
}
const _hoisted_44 = {
  key: 1,
  class: "h5"
}
const _hoisted_45 = { key: 5 }
const _hoisted_46 = { class: "h5" }
const _hoisted_47 = {
  key: 0,
  class: "h5"
}
const _hoisted_48 = {
  key: 1,
  class: "h5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "d-flex align-items-center" }, [
        _createElementVNode("img", {
          src: "/media/logos/iii-logo.png",
          alt: "",
          class: "h-100"
        }),
        _createElementVNode("h1", null, "INCLUSION IMPACT INDEX")
      ], -1)),
      _createElementVNode("img", {
        src: "/media/logos/bottom_logo.png",
        class: "h-50px",
        alt: _ctx.translate('VALORED_PROJECT_LOGO')
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSurveyStructureList, (stepList, index) => {
        return (_openBlock(), _createElementBlock("section", {
          slot: "pdf-content",
          class: "survey-summary",
          key: index + '_index'
        }, [
          _createElementVNode("section", _hoisted_5, [
            _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.surveyStepList[index][_ctx.translateKey("descrizione")]), 1),
            _createElementVNode("div", {
              class: "fw-bold fs-6 py-5",
              innerHTML: _ctx.translate(_ctx.messages_survey[index])
            }, null, 8, _hoisted_7)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stepList, (item, itemIndex) => {
            return (_openBlock(), _createElementBlock("section", {
              class: "pdf-item",
              key: itemIndex
            }, [
              (_ctx.getHeader(item.auto_number))
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.getHeader(item.auto_number)[_ctx.translateKey("message")]), 1)
                  ]))
                : _createCommentVNode("", true),
              (item.auto_number == 76)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "text-gray-600 fw-bold fs-6 mt-5",
                    innerHTML: _ctx.translate('SURVEY_1_MESSAGE_COMPOSIZIONE_DIPENDENTI_STAFF_LINEA')
                  }, null, 8, _hoisted_10))
                : _createCommentVNode("", true),
              (item.auto_number == 163)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: "text-gray-600 fw-bold fs-6 mt-5",
                    innerHTML: _ctx.translate('SURVEY_9_MESSAGE_CONGEDO_PARENTALE_PER_GENERE')
                  }, null, 8, _hoisted_11))
                : _createCommentVNode("", true),
              (item.sub_id == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("h5", _hoisted_13, _toDisplayString(item.set_id) + "." + _toDisplayString(item.id) + " " + _toDisplayString(item[_ctx.translateKey("name")]), 1),
                    _createElementVNode("div", _hoisted_14, [
                      (item.type == 'IntegerGenderField')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.translate("SURVEY_WOMEN_STRING")), 1),
                              (_ctx.surveyObj.getValue(item, 1))
                                ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_ctx.surveyObj.getValue(item, 1)), 1))
                                : (_openBlock(), _createElementBlock("p", _hoisted_19, " # "))
                            ]),
                            _createElementVNode("div", null, [
                              _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.translate("SURVEY_MEN_STRING")), 1),
                              (_ctx.surveyObj.getValue(item, 2))
                                ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(_ctx.surveyObj.getValue(item, 2)), 1))
                                : (_openBlock(), _createElementBlock("p", _hoisted_22, " # "))
                            ]),
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.translate("SURVEY_TOTAL_STRING")), 1),
                              (_ctx.surveyObj.getValue(item, 0))
                                ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(_ctx.surveyObj.getValue(item, 0)), 1))
                                : (_openBlock(), _createElementBlock("p", _hoisted_26, " # "))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (item.type == 'FloatGenderField')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            _createElementVNode("div", null, [
                              _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.translate("SURVEY_WOMEN_STRING")), 1),
                              (_ctx.surveyObj.getValue(item, 0))
                                ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(_ctx.surveyObj.getValue(item, 0)), 1))
                                : (_openBlock(), _createElementBlock("p", _hoisted_30, " # "))
                            ]),
                            _createElementVNode("div", null, [
                              _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.translate("SURVEY_MEN_STRING")), 1),
                              (_ctx.surveyObj.getValue(item, 1))
                                ? (_openBlock(), _createElementBlock("p", _hoisted_32, _toDisplayString(_ctx.surveyObj.getValue(item, 1)), 1))
                                : (_openBlock(), _createElementBlock("p", _hoisted_33, " # "))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (item.type == 'RoleGenderField')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                            _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.translate("SURVEY_SUMMARY_GENDER_STRING")), 1),
                            (_ctx.surveyObj.getValue(item, 0))
                              ? (_openBlock(), _createElementBlock("p", _hoisted_36, _toDisplayString(_ctx.surveyObj.getValue(item, 0)), 1))
                              : (_openBlock(), _createElementBlock("p", _hoisted_37, " (" + _toDisplayString(_ctx.translate("SURVEY_WOMEN_STRING")) + "/" + _toDisplayString(_ctx.translate("SURVEY_MEN_STRING")) + ") ", 1))
                          ]))
                        : _createCommentVNode("", true),
                      (item.type == 'SelectYesNoField')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                            _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.translate("SURVEY_SUMMARY_ANSWER_STRING")), 1),
                            (_ctx.surveyObj.getValue(item, 0))
                              ? (_openBlock(), _createElementBlock("p", _hoisted_40, _toDisplayString(_ctx.surveyObj.getValue(item, 0)), 1))
                              : (_openBlock(), _createElementBlock("p", _hoisted_41, _toDisplayString(_ctx.translate("SURVEY_STRUCTURE_SUMMARY_YES_NO_ALTERNATIVES")), 1))
                          ]))
                        : _createCommentVNode("", true),
                      (item.type == 'TextAreaField')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                            (_ctx.surveyObj.getValue(item, 0))
                              ? (_openBlock(), _createElementBlock("p", _hoisted_43, _toDisplayString(_ctx.surveyObj.getValue(item, 0)), 1))
                              : (_openBlock(), _createElementBlock("p", _hoisted_44, _toDisplayString(_ctx.translate("SURVEY_TEXTAREA_LABEL")), 1))
                          ]))
                        : _createCommentVNode("", true),
                      (item.type == 'PercentageField')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                            _createElementVNode("p", _hoisted_46, _toDisplayString(_ctx.translate("SURVEY_TOTAL_STRING")), 1),
                            (_ctx.surveyObj.getValue(item, 0))
                              ? (_openBlock(), _createElementBlock("p", _hoisted_47, _toDisplayString(_ctx.surveyObj.getValue(item, 0)) + "% ", 1))
                              : (_openBlock(), _createElementBlock("p", _hoisted_48, " ##% "))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      }), 128))
    ])
  ]))
}